<template>
  <div :ref="reference" class="site-drawer-wrapper" :style="{ zIndex: zIndex }">
    <transition v-if="overlay" name="fade">
      <div v-if="active" class="site-drawer-overlay" :style="{ 'background': overlay }"></div>
    </transition>

    <transition :name="position">
      <div v-show="active" class="site-drawer" :class="{ 'off-canvas': behavior === 'push', 'pos-left': position === 'left', 'pos-top': position === 'top', 'pos-right': position === 'right', 'pos-none': position === 'none' }">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { inject, ref, onMounted, onUnmounted } from 'vue';
const { instances, closeInstance } = inject('$siteDrawer');
const emit = defineEmits(['open', 'opened', 'close', 'closed']);

const props = defineProps({
  reference: {
    type: String,
    required: false,
    default: "menu",
  },
  position: {
    type: String,
    required: false,
    default: "fade",
  },
  behavior: {
    type: String,
    required: false,
    default: "overlay",
  },
  pushElement: {
    type: String,
    required: false,
    default: null,
  },
  zIndex: {
    type: String,
    required: false,
    default: "1000",
  },
  overlay: {
    type: String,
    required: false,
    default: null
  },
  disableOn: {
    type: String,
    required: false,
    default: null
  },
});

const active = ref(false);

const open = () => {
  active.value = true;
  emit('open');
  setTimeout(() => {
    emit('opened');
  }, 500);
}

const close = () => {
  active.value = false;
  emit('close');
  setTimeout(() => {
    emit('closed');
  }, 500);
}

onMounted(() => {
  instances.value.push({
    reference: props.reference,
    active: false,
    open,
    close,
  });

  // Close drawer on resize if viewport exceeds disableOn breakpoint
  if (props.disableOn) {
    const mediaQuery = window.matchMedia(`(min-width: ${props.disableOn}px)`);

    const handleMediaChange = (e) => {
      if (e.matches) {
        closeInstance(props.reference);
        // close();
      }
    };
    mediaQuery.addEventListener('change', handleMediaChange);

    // Store listener for cleanup
    // instances.value[instances.value.length - 1].mediaQuery = mediaQuery;
    // instances.value[instances.value.length - 1].handleMediaChange = handleMediaChange;
  }
});

// onUnmounted(() => {
//   // Clean up media query listener
//   const instance = getInstance();
//   if (instance && instance.mediaQuery && instance.handleMediaChange) {
//     instance.mediaQuery.removeEventListener('change', instance.handleMediaChange);
//   }
// });

// const $pushElement = document.querySelector(this.pushElement);
//     if ($pushElement) {
//       // $pushElement.style.transition = "left 350ms ease-in-out, opacity 250ms 350ms ease-in-out";
//       $pushElement.style.zIndex = "2";
//       $pushElement.style.boxShadow = "20px 0px 30px #0000004D";
//     }
</script>

<style lang="scss">
.site-drawer-wrapper {
  position: relative;

  .site-drawer {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    height: 100vh;
    width: 100%;
    min-width: 200px;

    &.off-canvas {
      display: block !important;
    }

    &.pos-top {
      top: 0;
      left: 0;
    }

    &.pos-right {
      right: 0;
      top: 0;
    }

    &.pos-left {
      left: 0;
      top: 0;
    }
  }

  .site-drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
  }
}

// Transitions
.top-enter-active,
.top-leave-active,
.right-enter-active,
.right-leave-active,
.left-enter-active,
.left-leave-active {
  transition: transform 1000ms ease-out;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms ease-out;
}

.top-enter-from,
.top-leave-to {
  transform: translateY(-100%);
}

.right-enter-from,
.right-leave-to {
  transform: translateX(100%);

  &.off-canvas {
    transform: translateX(0%);
  }
}

.left-enter-from,
.left-leave-to {
  transform: translateX(-100%);

  &.off-canvas {
    transform: translateX(0%);
  }
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>